import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../views/Home";
import InfoPage from "../views/InfoPage";
import AboutPage from "../views/AboutPage";
import HelpPage from "../views/HelpPage";
import LegalPage from "../views/LegalPage";
import RulesPage from "../views/RulesPage";
import Stories from "../views/Stories";
import Profile from "../views/Profile";
import ProfileEdit from "../views/ProfileEdit";
import Friends from "../views/Friends";
import MyFriends from "../views/MyFriends";
import Threads from "../views/Threads";
import Guests from "../views/Guests";
import Albums from "../views/Albums";
import AlbumsEdit from "../views/AlbumsEdit";
import Photos from "../views/Photos";
import Games from "../views/Games";
import Game from "../views/Game";
import Puzzles from "../views/Puzzles";
import MyPuzzles from "../views/MyPuzzles";
import Events from "../views/Events";
import Settings from "../views/Settings";
import Horoscope from "../views/Horoscope";
import Tests from "../views/Tests";
import Test from "../views/Test";
import Search from "../views/Search";
import Feedback from "../views/Feedback";
import QiuckRegistration from "../views/QiuckRegistration";
import Balance from "../views/Balance";
import Moderation from "../views/Moderation.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "home",
        component: Home,
    },
    {
        path: "/balance",
        name: "balance",
        component: Balance,
    },
    {
        path: "/reset_password/confirm/:uid/:token",
        name: "reset",
        component: Home,
    },
    {
        path: "/?ref_code=/:ref_code",
        name: "send-ref-code",
        component: Home,
    },
    {
        path: "/stories",
        name: "stories",
        component: Stories,
    },
    {
        path: "/profile/:id?",
        name: "profile",
        component: Profile,
    },
    {
        path: "/profile-edit",
        name: "profile-edit",
        component: ProfileEdit,
    },
    {
        path: "/friends/:id",
        name: "friends",
        component: Friends,
    },
    {
        path: "/my-friends",
        name: "my_friends",
        component: MyFriends,
    },
    {
        path: "/guests",
        name: "guests",
        component: Guests,
    },
    {
        path: "/threads/:id?",
        name: "threads",
        component: Threads,
    },
    {
        path: "/albums/:profileId",
        name: "albums",
        component: Albums,
        meta: { type: "photos" },
    },
    {
        path: "/albums-edit/:albumId",
        name: "albums-edit",
        component: AlbumsEdit,
        meta: { type: "photos" },
    },
    {
        path: "/photos/:profileId?/:albumId",
        name: "photos",
        component: Photos,
        meta: { type: "photos" },
    },
    {
        path: "/video-albums/:profileId",
        name: "video-albums",
        component: Albums,
        meta: { type: "videos" },
    },
    {
        path: "/video-albums-edit/:albumId",
        name: "video-albums-edit",
        component: AlbumsEdit,
        meta: { type: "videos" },
    },
    {
        path: "/videos/:profileId?/:albumId",
        name: "videos",
        component: Photos,
        meta: { type: "videos" },
    },
    {
        path: "/games",
        name: "games",
        component: Games,
    },
    {
        path: "/game/:id/:lobbyId?",
        name: "game",
        component: Game,
    },
    {
        path: "/puzzles",
        name: "puzzles",
        component: Puzzles,
    },
    {
        path: "/my-puzzles",
        name: "my-puzzles",
        component: MyPuzzles,
    },
    {
        path: "/events",
        name: "events",
        component: Events,
    },
    {
        path: "/settings",
        name: "settings",
        component: Settings,
    },
    {
        path: "/horoscope",
        name: "horoscope",
        component: Horoscope,
    },
    {
        path: "/tests",
        name: "tests",
        component: Tests,
    },
    {
        path: "/test/:id",
        name: "test",
        component: Test,
    },
    {
        path: "/about",
        name: "about",
        component: AboutPage,
    },
    {
        path: "/rules",
        name: "rules",
        component: RulesPage,
    },
    {
        path: "/help",
        name: "help",
        component: HelpPage,
    },
    {
        path: "/legal",
        name: "legal",
        component: LegalPage,
    },
    {
        path: "/developers",
        name: "developers",
        component: InfoPage,
    },
    {
        path: "/advertising",
        name: "advertising",
        component: InfoPage,
    },
    {
        path: "/search",
        name: "search",
        component: Search,
    },
    {
        path: "/feedback",
        name: "feedback",
        component: Feedback,
    },
    {
        path: "/quick-registration/:id?",
        name: "quick-registration",
        component: QiuckRegistration,
    },
    {
        path: "/moderation",
        name: "moderation",
        component: Moderation,
    },
];

export default new VueRouter({
    routes,
});
